/**
 * @generated SignedSource<<a44a9e1bf57ec006f3b6c1393fd98da6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ScrapSourceBookCreateInput = {
  bookId: string;
};
export type ScrapSourceBookCreateDialog_scrapSourceBookCreateMutation$variables = {
  input: ScrapSourceBookCreateInput;
};
export type ScrapSourceBookCreateDialog_scrapSourceBookCreateMutation$data = {
  readonly scrapSourceBookCreate: {
    readonly id: string;
  };
};
export type ScrapSourceBookCreateDialog_scrapSourceBookCreateMutation = {
  response: ScrapSourceBookCreateDialog_scrapSourceBookCreateMutation$data;
  variables: ScrapSourceBookCreateDialog_scrapSourceBookCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ScrapSource",
    "kind": "LinkedField",
    "name": "scrapSourceBookCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ScrapSourceBookCreateDialog_scrapSourceBookCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ScrapSourceBookCreateDialog_scrapSourceBookCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a0db80f7871449c305ed7f5d9fa11ce1",
    "id": null,
    "metadata": {},
    "name": "ScrapSourceBookCreateDialog_scrapSourceBookCreateMutation",
    "operationKind": "mutation",
    "text": "mutation ScrapSourceBookCreateDialog_scrapSourceBookCreateMutation(\n  $input: ScrapSourceBookCreateInput!\n) {\n  scrapSourceBookCreate(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a1344974c68d48f2751a7e90b2fd32d4";

export default node;
